"use strict";

const ActivityTypesLoading = () => (
  <div className="w-100 d-f btn-group" style={{height: 43}}>
    <span className="btn flex-1 d-f jc-sa btn-filter">
      <div>
        <div className="activityTypeLoading"></div>
      </div>
    </span>
    <span className="btn flex-1 d-f jc-sa btn-filter">
      <div>
        <div className="activityTypeLoading"></div>
      </div>
    </span>
    <span className="btn flex-1 d-f jc-sa btn-filter">
      <div>
        <div className="activityTypeLoading"></div>
      </div>
    </span>
    <span className="btn flex-1 d-f jc-sa btn-filter">
      <div>
        <div className="activityTypeLoading"></div>
      </div>
    </span>
    <span className="btn flex-1 d-f jc-sa btn-filter">
      <div>
        <div className="activityTypeLoading"></div>
      </div>
    </span>
  </div>
);

module.exports = ActivityTypesLoading;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/ActivityInput/activity-types-loading.jsx